export const printengineRouteDef = [ 
    {
        path:'print_settings/list',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'print_settings',
            action: 'LIST',
        }
    },
    {
        path:'print_settings/debug',
        component:'PrintEngineDebugComponent',
        data : {
            selector: 'app-print-engine-debug'
        }
    }    
]       